module.exports = __webpack_public_path__ + "img/cs_logo.2c4ced42.png";